export enum SectionParentType {
    Annex = "annex",
    AnnexGroup = "annexGroup",
    Article = "article",
    Chapter = "chapter",
}
